export class IncomeFlag {
    static isUpdate = true;
    static id = '';
    static typeUser = '';
    static typeGetListService = 'individual';
}
